import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {
  public transform(value, keys: string, term: string) {
    if (!term) {
      return value;
    }
    let result: any[] = [];
    let termArray = term.split(" ");
    termArray.forEach((val) => {
      result = (value || []).filter(item =>
        keys.split(',').some(key => item.hasOwnProperty(key) && item[key] != null && item[key] != undefined && JSON.stringify(item[key]).toLowerCase().includes(val.toLowerCase()))
      );
      value = result;
    });
    return result;
  }
}

